<template>
    <div class="vue-account-orders">
        <a :href="productOverviewUrl" class="btn-primary">{{ newOrderText }}</a>

        <div class="orders-wrapper mt-7">
            <h4>{{ orderHistoryText }}</h4>

            <div class="row mt-5 px-4 d-none d-lg-flex">
                <div class="col-lg-3">
                    {{ orderNumberText }}
                </div>
                <div class="col-lg-3">
                    {{ orderDateText }}
                </div>
                <div class="col-lg-3">
                    {{ amountText }}
                </div>
                <div class="col-lg-3">
                    {{ totalTaxText }}
                </div>
            </div>

            <div class="row mt-2">
                <div class="col-12">
                    <dentaid-order-line
                        v-if="hasOrders && !loading"
                        v-for="(order, index) in orders"
                        :key="index"
                        :jwt-token="jwtToken"
                        :order="order"
                        :lang-code="langCode"
                        :dentaid-api-instance="dentaidApiInstance"
                        :cart-event-bus="cartEventBus"
                    ></dentaid-order-line>
                </div>
            </div>

            <div class="row my-5" v-if="loading">
                <div class="col-12 text-align-center">
                    {{ loadingText }}
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import jwtToken from "../mixins/jwt-token";
import OrderLine from "./OrderLine";

export default {
    name: "AccountOrders",

    mixins: [jwtToken],

    components: {
        'dentaid-order-line': OrderLine,
    },

    props: {
        cartEventBus: {},
        dentaidApiInstance: {},
        langCode: {
            default: 'nl'
        },
        productOverviewUrl: {
            type: String,
        }
    },

    data() {
        return {
            orders: null,
            loading: true,
            loadingText: window.Drupal.t('Loading...'),
            newOrderText: window.Drupal.t('Create a new order'),
            orderHistoryText: window.Drupal.t('Order history'),
            orderNumberText : window.Drupal.t('Order number'),
            orderDateText: window.Drupal.t('Order date'),
            amountText: window.Drupal.t('Amount'),
            totalTaxText: window.Drupal.t('Total (excl. VAT.)'),
        }
    },

    computed: {
        hasOrders() {
            return ! lodash.isNil(this.orders);
        }
    },

    mounted() {
        this.eventBus.$on('alive', () => this.fetchOrders());
    },

    methods: {
        fetchOrders() {
            this.dentaidApiInstance.get(`/orders?token=${this.jwtToken}&lang=${this.langCode}`)
                .then(response => {
                    this.orders = response.data.data;
                })
                .catch(error => {
                    console.log(error);
                    this.orders = null;
                })
                .finally(() => this.loading = false);
        }
    }
}
</script>